/**
 * Leaflet.ChineseTmsProviders
 * 用于支持中国地图服务提供商的Leaflet插件
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['leaflet'], factory);
    } else if (typeof modules === 'object' && module.exports) {
        // Node & CommonJS
        module.exports = factory(require('leaflet'));
    } else {
        // 浏览器全局变量
        if (typeof window.L === 'undefined') {
            throw new Error('Leaflet必须先加载');
        }
        factory(window.L);
    }
}(this, function (L) {
    'use strict';

    L.TileLayer.ChinaProvider = L.TileLayer.extend({
        initialize: function(type, options) {
            var providers = L.TileLayer.ChinaProvider.providers;
            var parts = type.split('.');
            var providerName = parts[0];
            var mapName = parts[1];
            var mapType = parts[2];

            var url = providers[providerName][mapName][mapType];
            options.subdomains = providers[providerName].Subdomains;
            options.key = options.key || providers[providerName].key;
            
            if(options.key) {
                url = url.replace('{key}', options.key);
            }

            L.TileLayer.prototype.initialize.call(this, url, options);
        }
    });

    L.TileLayer.ChinaProvider.providers = {
        TianDiTu: {
            Normal: {
                Map: "https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk={key}",
                Annotion: "https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk={key}"
            },
            Satellite: {
                Map: "https://t{s}.tianditu.gov.cn/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk={key}",
                Annotion: "https://t{s}.tianditu.gov.cn/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk={key}"
            },
            Terrain: {
                Map: "https://t{s}.tianditu.gov.cn/DataServer?T=ter_w&X={x}&Y={y}&L={z}&tk={key}",
                Annotion: "https://t{s}.tianditu.gov.cn/DataServer?T=cta_w&X={x}&Y={y}&L={z}&tk={key}"
            },
            Subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
            key: "038937b9b91fd28203af58e3dd9b1396"
        },
        GaoDe: {
            Normal: {
                Map: 'https://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
            },
            Satellite: {
                Map: 'https://webst0{s}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
                Annotion: 'https://webst0{s}.is.autonavi.com/appmaptile?style=8&x={x}&y={y}&z={z}'
            },
            Subdomains: ["1", "2", "3", "4"]
        },
        Google: {
            Normal: {
                Map: "https://maps.googleapis.com/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
            },
            Satellite: {
                Map: "https://maps.googleapis.com/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}",
                Annotion: "https://maps.googleapis.com/maps/vt?lyrs=y@189&gl=cn&x={x}&y={y}&z={z}"
            },
            Subdomains: []
        },
        Geoq: {
            Normal: {
                Map: "https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer/tile/{z}/{y}/{x}",
                PurplishBlue: "https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}",
                Gray: "https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}",
                Warm: "https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetWarm/MapServer/tile/{z}/{y}/{x}",
            },
            Subdomains: []
        },
        OSM: {
            Normal: {
                Map: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
            },
            Subdomains: ['a', 'b', 'c']
        }
    };

    L.tileLayer.chinaProvider = function(type, options) {
        return new L.TileLayer.ChinaProvider(type, options);
    };

    return L.TileLayer.ChinaProvider;
})); 